<template>
  <authorization permissionKey="attendance_contact_lens_test" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Testes de lentes de contato
        </v-col>

        <authorization
          permissionKey="attendance_contact_lens_test"
          can="save"
          v-slot:default="{ authorization }"
        >
          <v-col cols="auto" v-if="authorization">
            <v-btn
              color="light-blue"
              @click="createTest"
              :dark="!attendanceEsigned"
              :disabled="attendanceEsigned"
            >
              Adicionar
            </v-btn>
          </v-col>
        </authorization>
      </v-row>

      <ContactLensTestList :attendance="attendance" :disabled="attendanceEsigned" />
    </v-container>
  </authorization>
</template>

<script>
  import ContactLensTestList from "@/components/contact_lens_test/list/index.vue";

  export default {
    name: "ContactLensTests",
    components: {
      ContactLensTestList,
    },
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
    methods: {
      createTest() {
        return this.apolloMutate({
          mutation: require("@/graphql/contact_lens_test/save_contact_lens_test.gql"),
          variables: {
            attendanceId: this.attendance.id,
          },
        }).then(({ data }) => {
          this.$router.push(
            `/prontuario/${this.attendance.id}/lentes-contato/${data.saveContactLensTest.id}`
          );
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
